import { RadioGroup } from '@ovComponents/2-component/radio/radio';
import { Box, Grid, Typography, useTheme } from 'hephaestus/web';
import { useSelectionChipTokens } from './selectionChip.tokens';

type SelectionChipProps = {
  type?: 'checkbox' | 'radio';
  value: string | number;
  options: Array<{
    label: string;
    subtitle?: string;
    value: string | number;
    dataTestId?: string;
  }>;
  onChange: any;
};

export const SelectionChip = ({
  type = 'radio',
  value,
  options,
  onChange,
}: SelectionChipProps) => {
  const theme = useTheme();
  const tokens = useSelectionChipTokens(theme);

  if (type === 'radio') {
    return (
      <RadioGroup value={value} label='' onChange={onChange} fullWidth>
        <Grid
          container
          sx={{
            width: '100%',
          }}
        >
          {(options || []).map((option, index) => (
            <Box
              data-testid={option?.dataTestId}
              key={index}
              onClick={() => onChange(option.value)}
              sx={{
                justifyContent: 'center',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',

                color:
                  value === option.value
                    ? tokens.text.active
                    : tokens.text.default,

                borderRadius: tokens.borderRadius,

                backgroundColor:
                  value === option.value
                    ? tokens.background.active
                    : tokens.background.default,

                padding: '8px',
                mt: 1,
                mr: 1.5,

                '&:hover': {
                  color: tokens.text.hover,
                  cursor: 'pointer',
                },
              }}
            >
              <Typography variant='bodySmall' sx={{ fontWeight: 600 }}>
                {option.label}
              </Typography>
            </Box>
          ))}
        </Grid>
      </RadioGroup>
    );
  }
  return (
    // TODO: Checkbox
    <></>
  );
};

export default SelectionChip;
